import { useState, useEffect } from "react";
import { getSources } from "../../carbonApi";

const safeParse = (s) => {
  try { return JSON.parse(s); } catch { return null; }
};

/**
 * Reference data for the carbon-footprint comparison selectors: financial years
 * (from the cached list the app already stores) and the company's locations
 * (via the existing getSource endpoint), flattened to { id, name }.
 */
export const useScopeRefData = () => {
  const [financialYears] = useState(
    () => safeParse(localStorage.getItem("financialYears")) || [],
  );
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await getSources();
        if (alive && res?.isSuccess && res.data?.data) {
          setLocations(
            res.data.data.map((l) => ({
              id: l.id,
              name:
                l.unitCode ||
                `${l?.location?.area || ""} ${l?.location?.city || ""} ${l?.location?.state || ""}`
                  .replace(/\s+/g, " ")
                  .trim() ||
                `Location ${l.id}`,
            })),
          );
        }
      } catch (err) {
        console.error("Failed to load locations for comparison", err);
      }
    })();
    return () => { alive = false; };
  }, []);

  return { financialYears, locations };
};

export default useScopeRefData;
